// extracted by mini-css-extract-plugin
export default {"textInput":"CustomerDetailsForm_textInput__MJw6y","buttonContainer":"CustomerDetailsForm_buttonContainer__4xOJC","marginBottom":"CustomerDetailsForm_marginBottom__nRa5r"};